//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    edit() {
      this.editMode = true;
      this.$emit("edit");
    },
    save() {
      this.editMode = false;
      this.$emit("save");
    },
  },
  props: {
    title: {
      default: "Title",
    },
    large: {
      default: false,
    },
    medium: {
      default: false,
    },
    small: {
      default: false,
    },
    createButton: {
      default: false,
    },
  },
};
